
import React from 'react';

export const UploadInstructions = () => {
  return (
    <div className="text-sm text-gray-500 mt-2">
      <p>The Excel file should have the following columns:</p>
      <ul className="list-disc pl-5 mt-1">
        <li><strong>Όνομα</strong> (First Name) - Required</li>
        <li><strong>Επώνυμο</strong> (Last Name) - Required</li>
        <li>Κωδικός</li>
        <li>Email</li>
        <li>Πρόσληψη (προαιρετικό)</li>
        <li>Ημερ.γέννησης (προαιρετικό)</li>
        <li>ΛΗΞΗ ΑΔΕΙΑΣ (προαιρετικό)</li>
        <li>ΑΦΜ (προαιρετικό)</li>
        <li>Ομάδα (προαιρετικό)</li>
        <li>Κινητό (προαιρετικό)</li>
      </ul>
      <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-md">
        <p className="font-medium text-amber-800">Important Notes</p>
        <ul className="list-disc pl-5 text-amber-700 mt-1">
          <li><span className="font-semibold">First and Last Name must be in separate columns</span></li>
          <li>Both First Name (Όνομα) and Last Name (Επώνυμο) are required</li>
          <li>The system will use these two fields to create the full name</li>
          <li>If either name is missing, the record will be skipped with an error</li>
        </ul>
      </div>
      <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-md">
        <p className="font-medium text-amber-800">Large Uploads (Over 100 Guards)</p>
        <ul className="list-disc pl-5 text-amber-700 mt-1">
          <li>A 25-second pause is added between each guard to avoid rate limits</li>
          <li>Individual notifications are suppressed for batches over 30 guards</li>
          <li>Progress badges show real-time processing stats</li>
          <li>The entire process may take a while, please be patient</li>
          <li>You'll receive batch progress updates every 20 guards</li>
        </ul>
      </div>
    </div>
  );
};
